import vine from '@vinejs/vine'
import type { FieldContext } from '@vinejs/vine/types'
import '~/validators/configureVine'

import {
  ORG_RICH_TEXT_HTML_MAX,
  ORG_RICH_TEXT_VISIBLE_MAX,
  visibleTextLength,
} from '~/utils/orgRichText'

type VisibleMaxOptions = {
  max: number
}

const visibleTextMaxLength = vine.createRule(
  (value: unknown, options: VisibleMaxOptions, field: FieldContext) => {
    if (typeof value !== 'string') {
      return
    }
    if (visibleTextLength(value) > options.max) {
      field.report(
        'The {{ field }} field must not be greater than {{ max }} characters',
        'maxLength',
        field,
        options,
      )
    }
  },
)

export function orgRichTextVine(maxVisible = ORG_RICH_TEXT_VISIBLE_MAX) {
  return vine
    .string()
    .trim()
    .maxLength(ORG_RICH_TEXT_HTML_MAX)
    .use(visibleTextMaxLength({ max: maxVisible }))
}
